var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreAltIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7056 -10504C-7056 -10557 -7013.02 -10600 -6960 -10600H9982C10035 -10600 10078 -10557 10078 -10504V18390C10078 18443 10035 18486 9982 18486H-6960C-7013.02 18486 -7056 18443 -7056 18390V-10504Z",
    fill: "#EEF6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-6960 -10585H9982V-10615H-6960V-10585ZM10063 -10504V18390H10093V-10504H10063ZM9982 18471H-6960V18501H9982V18471ZM-7041 18390V-10504H-7071V18390H-7041ZM-6960 18471C-7004.74 18471 -7041 18434.7 -7041 18390H-7071C-7071 18451.3 -7021.3 18501 -6960 18501V18471ZM10063 18390C10063 18434.7 10026.7 18471 9982 18471V18501C10043.3 18501 10093 18451.3 10093 18390H10063ZM9982 -10585C10026.7 -10585 10063 -10548.7 10063 -10504H10093C10093 -10565.3 10043.3 -10615 9982 -10615V-10585ZM-6960 -10615C-7021.3 -10615 -7071 -10565.3 -7071 -10504H-7041C-7041 -10548.7 -7004.74 -10585 -6960 -10585V-10615Z",
    fill: "#5DA5D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-4826 -1242C-4826 -1277.35 -4797.35 -1306 -4762 -1306H4462C4497.35 -1306 4526 -1277.35 4526 -1242V1038C4526 1073.35 4497.35 1102 4462 1102H-4762C-4797.35 1102 -4826 1073.35 -4826 1038V-1242Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-4762 -1296H4462V-1316H-4762V-1296ZM4516 -1242V1038H4536V-1242H4516ZM4462 1092H-4762V1112H4462V1092ZM-4816 1038V-1242H-4836V1038H-4816ZM-4762 1092C-4791.82 1092 -4816 1067.82 -4816 1038H-4836C-4836 1078.87 -4802.87 1112 -4762 1112V1092ZM4516 1038C4516 1067.82 4491.82 1092 4462 1092V1112C4502.87 1112 4536 1078.87 4536 1038H4516ZM4462 -1296C4491.82 -1296 4516 -1271.82 4516 -1242H4536C4536 -1282.87 4502.87 -1316 4462 -1316V-1296ZM-4762 -1316C-4802.87 -1316 -4836 -1282.87 -4836 -1242H-4816C-4816 -1271.82 -4791.82 -1296 -4762 -1296V-1316Z",
    fill: "#5DA5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-1127 -1142C-1127 -1177.35 -1098.35 -1206 -1063 -1206H550C585.346 -1206 614 -1177.35 614 -1142V938C614 973.346 585.346 1002 550 1002H-1063C-1098.35 1002 -1127 973.346 -1127 938V-1142Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-1063 -1196H550V-1216H-1063V-1196ZM604 -1142V938H624V-1142H604ZM550 992H-1063V1012H550V992ZM-1117 938V-1142H-1137V938H-1117ZM-1063 992C-1092.82 992 -1117 967.823 -1117 938H-1137C-1137 978.869 -1103.87 1012 -1063 1012V992ZM604 938C604 967.823 579.823 992 550 992V1012C590.869 1012 624 978.869 624 938H604ZM550 -1196C579.823 -1196 604 -1171.82 604 -1142H624C624 -1182.87 590.869 -1216 550 -1216V-1196ZM-1063 -1216C-1103.87 -1216 -1137 -1182.87 -1137 -1142H-1117C-1117 -1171.82 -1092.82 -1196 -1063 -1196V-1216Z",
    fill: "#60C2A5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-309 3.8147e-06C-309 -16.0163 -296.016 -29 -280 -29H73V394C73 410.016 60.0163 423 44 423H-280C-296.016 423 -309 410.016 -309 394V3.8147e-06Z",
    fill: "#EEF6FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-309 3.8147e-06C-309 -16.0163 -296.016 -29 -280 -29H73V394C73 410.016 60.0163 423 44 423H-280C-296.016 423 -309 410.016 -309 394V3.8147e-06Z",
    stroke: "#5DA5D9",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#9EC9E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24C16.1046 24 17 23.1046 17 22C17 20.8954 16.1046 20 15 20C13.8954 20 13 20.8954 13 22C13 23.1046 13.8954 24 15 24Z",
    fill: "#284993"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24C23.1046 24 24 23.1046 24 22C24 20.8954 23.1046 20 22 20C20.8954 20 20 20.8954 20 22C20 23.1046 20.8954 24 22 24Z",
    fill: "#284993"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29 24C30.1046 24 31 23.1046 31 22C31 20.8954 30.1046 20 29 20C27.8954 20 27 20.8954 27 22C27 23.1046 27.8954 24 29 24Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreAltIcon);
export default __webpack_public_path__ + "static/media/MoreAltIcon.87b4e9581ef19946cfeb938940482000.svg";
export { ForwardRef as ReactComponent };